/**
 * useMediaQuery hook — replacement for MUI's useMediaQuery().
 *
 * Uses window.matchMedia() directly, no MUI dependency.
 */

import { useSyncExternalStore } from 'react'

/**
 * Subscribe to a media query and return whether it matches.
 *
 * @example
 * const isMobile = useMediaQuery('(max-width: 599px)')
 * const prefersDark = useMediaQuery('(prefers-color-scheme: dark)')
 */
export const useMediaQuery = (query: string): boolean => {
  const subscribe = (callback: () => void) => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {return () => {}}
    const mql = window.matchMedia(query)
    mql.addEventListener('change', callback)
    return () => mql.removeEventListener('change', callback)
  }

  const getSnapshot = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {return false}
    return window.matchMedia(query).matches
  }

  const getServerSnapshot = () => false

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}
